import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=48074449&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=48074449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48074449",
  null
  
)

export default component.exports